import { listReadableForAccount } from './common'
import { getDocRef, getRootCollection } from './queries'

export const listAssets = () => getRootCollection('assetRegister')

const whereDocSigned = (query) => query.where('docSigned', '==', true)

export const listReadableAssetsForAccount = listReadableForAccount(
  listAssets,
  whereDocSigned
)

export const getAssetRef = getDocRef(listAssets)
